/**
 * Turkish character normalization for search.
 * Converts Turkish special chars to ASCII equivalents for case-insensitive matching.
 * "Hüyük" matches "huyuk", "HÜYÜK" matches "huyuk" etc.
 */
const TR_MAP = {
  'ı': 'i', 'İ': 'i', 'ö': 'o', 'Ö': 'o', 'ü': 'u', 'Ü': 'u',
  'ş': 's', 'Ş': 's', 'ç': 'c', 'Ç': 'c', 'ğ': 'g', 'Ğ': 'g',
};

export function normalizeTurkish(str) {
  if (!str) return '';
  return str.replace(/[ıİöÖüÜşŞçÇğĞ]/g, (ch) => TR_MAP[ch] || ch).toLowerCase();
}

/**
 * Check if `text` contains `query` with Turkish char normalization.
 */
export function turkishIncludes(text, query) {
  return normalizeTurkish(text).includes(normalizeTurkish(query));
}
